import styled from '@emotion/styled';
import {Typography, Button} from '@mui/material';

export const WidgetStyle = styled.div<{drawerOpen: boolean}>`
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 10px;
  padding: ${props => (props.drawerOpen ? '0.75rem' : '0.25')};
  width: ${props => (props.drawerOpen ? '8rem' : '3rem')};
  cursor: pointer;
  margin-bottom: 0.5rem;

  &:hover {
    border: 1px solid #1976d2;
  }
`;

export const FontStyle = styled(Typography)`
  text-align: center;
  color: #4d4d4d;

  &:hover {
    color: #1976d2;e
  }
`;

export const WidgetButton = styled(Button)`
  text-transform: none;
  justify-content: flex-start;
  padding: 0 1.5rem;
  font-size: 0.8rem;

  .MuiButton-startIcon {
    margin-top: 0 !important;
  }
`;
